import $ from 'jquery';
import focusAreaClass from './focus-area';
import overlayEl from './overlay';
import StayTabClass from './stay';
import GatherTabClass from './gather';
import InputClass from './input';
import TableTabClass from './table';
import TableSignatureClass from './table-signature';
import TabSpaClass from './spa';

class Booking {
  options = {
    classes: {
      container: '.booking-widget',
      close: '.booking-widget__close .c-cross',
      open: '.book-now__button, .capacity-charts__link',
    },
    duration: 300,
    defaultTab: 'stay',
  };

  constructor() {
    this.booking = $(this.options.classes.container);
    this.openClass = 'open';
    this.closeButton = this.booking.find(this.options.classes.close);
    this.openButton = $(this.options.classes.open);
    this.dialogTriggers = this.openButton.filter('[aria-haspopup="dialog"]');
    this.activeTrigger = $();
    this.stayTab = new StayTabClass();
    this.gatherTab = new GatherTabClass();
    this.tabelTab = new TableTabClass();
    this.tableSignatureTab = new TableSignatureClass();
    this.TabSpa = new TabSpaClass();
    this.input = new InputClass();
    focusAreaClass(this.options.classes.container, this.options.classes.close);

    this.booking.on('keydown', 'input, select, textarea', (e) => {
      if (e.key === 'Enter') {
        if (!$(this).is('textarea')) {
          e.preventDefault();
          return false;
        }
      }

      return true;
    });

    // Handle submit button focus management
    this.booking.on('keydown', 'input[type="submit"], button[type="submit"], .wpcf7-submit', (e) => {
      if (e.key === 'Tab' && !e.shiftKey) {
        const form = $(e.target).closest('form')[0];
        if (form) {
          const firstFocusableElement = form.querySelector('input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
          if (firstFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    });
  }

  open(selectedTab) {
    const tab = selectedTab || this.options.defaultTab;

    this.activeTrigger = $(document.activeElement).filter(this.options.classes.open);

    if (this.booking.hasClass(this.openClass)) {
      return false;
    }

    overlayEl.open();
    this.booking.stop().show().animate({ right: 0 }, this.options.duration, 'linear', this.#afterOpen.bind(this));

    $(`#${tab}-tab`).click();
    return true;
  }

  #afterOpen() {
    this.booking.addClass(this.openClass).attr('aria-hidden', 'false');
    $('body > :visible:not(.booking-widget):not(.c-overlay)').attr('aria-hidden', 'true');
    this.dialogTriggers.attr('aria-expanded', 'true');
    this.closeButton.focus();
  }

  close() {
    window.history.pushState(null, null, window.location.origin + window.location.pathname);
    overlayEl.close();
    this.booking.stop().animate({ right: -1 * this.booking.width() }, this.options.duration, 'linear', this.#afterClose.bind(this));

    return true;
  }

  #afterClose() {
    this.booking.hide().removeClass(this.openClass).attr('aria-hidden', 'true');
    $('body > :visible:not(.booking-widget):not(.c-overlay)').removeAttr('aria-hidden');
    this.dialogTriggers.attr('aria-expanded', 'false');
    this.activeTrigger.focus();
  }
}

const booking = new Booking();

export default booking;
